import React from "react";

const Volume = ({ color = "var(--primary-color", size = "24" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7479 5C21.1652 6.97024 22 9.38764 22 12C22 14.6124 21.1652 17.0298 19.7479 19M15.7453 8C16.5362 9.13384 17 10.5128 17 12C17 13.4873 16.5362 14.8662 15.7453 16M9.63432 4.36569L6.46863 7.53137C6.29568 7.70433 6.2092 7.7908 6.10828 7.85264C6.01881 7.90747 5.92127 7.94788 5.81923 7.97237C5.70414 8 5.58185 8 5.33726 8H3.6C3.03995 8 2.75992 8 2.54601 8.109C2.35785 8.20487 2.20487 8.35785 2.10899 8.54601C2 8.75992 2 9.03995 2 9.6V14.4C2 14.9601 2 15.2401 2.10899 15.454C2.20487 15.6422 2.35785 15.7951 2.54601 15.891C2.75992 16 3.03995 16 3.6 16H5.33726C5.58185 16 5.70414 16 5.81923 16.0276C5.92127 16.0521 6.01881 16.0925 6.10828 16.1474C6.2092 16.2092 6.29568 16.2957 6.46863 16.4686L9.63431 19.6343C10.0627 20.0627 10.2769 20.2769 10.4608 20.2914C10.6203 20.3039 10.7763 20.2393 10.8802 20.1176C11 19.9774 11 19.6744 11 19.0686V4.93137C11 4.32556 11 4.02265 10.8802 3.88239C10.7763 3.76068 10.6203 3.69609 10.4608 3.70865C10.2769 3.72312 10.0627 3.93731 9.63432 4.36569Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Volume;
